import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home_def",
  "use": "icon-home_def-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-home_def\"><path d=\"M1000.302571 414.303667L541.736399 11.634952a48.65149 48.65149 0 0 0-63.143424 0L20.026803 414.303667a50.721766 50.721766 0 0 0 31.054143 91.092152h918.167482a49.686628 49.686628 0 0 0 47.616352-34.159557 51.756904 51.756904 0 0 0-16.562209-56.932595zM153.559616 931.87271a92.12729 92.12729 0 0 0 92.12729 92.12729h162.51668v-258.784521a93.162428 93.162428 0 0 1 81.775908-103.513809h40.370386a93.162428 93.162428 0 0 1 81.775908 103.513809v254.643969h162.51668A92.12729 92.12729 0 0 0 866.769758 931.87271V517.817476H153.559616z\" p-id=\"949\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home_def.svg
// module id = 1qp9
// module chunks = 44